import { useSuspenseQuery } from '@tanstack/react-query';

import { RecommendationArticleParams } from '@/entities/article';
import { clientAxios } from '@/shared/api';
import { PATH } from '@/shared/constants';
import { ApiResponse, ArticleResponseItem } from '@/shared/types';

const fetchTargetRecommendationContents = async ({
  year,
  role,
}: RecommendationArticleParams) => {
  const { data } = await clientAxios.get<ApiResponse<ArticleResponseItem[]>>(
    '/landingTargetRecommendationArticleListApi/',
    {
      params: { year, role },
    }
  );

  return data.data.map((article) => ({
    articleInfo: {
      id: article.id,
      category: article.category[0].name,
      categoryFlag: article.category[0].flag,
      time: article.read_time,
      title: article.title,
      isPopular: article.is_popular_news,
      isScrapped: article.is_news_scrapped,
      imageUrl: article.thumbnail_image,
    },
    authorInfo: {
      name: article.author.name,
      href: `${PATH.HOME}/@${article.author.author_url_identifier}`,
      imgUrl: article.author.image_url,
    },
  }));
};

export const useTargetRecommendationContents = (
  params: RecommendationArticleParams
) => {
  const query = useSuspenseQuery({
    queryKey: ['targetRecommendationContents', params],
    queryFn: async () => fetchTargetRecommendationContents(params),
  });

  return query;
};
